import React from 'react'
import PublicLayout from '@/pages/PublicLayout';
import Simple from '@/components/layouts/AuthLayout/Simple';
import SignIn from '@/components/pages/auth/SignIn';
import { Head } from '@inertiajs/react';

const SignInPage = () => {

  return (
    <>
      <Head>
        <title>Sign In</title>
        <meta name="description" content="Sign in to Memo Slate to access your secure notes. Protect your thoughts and ideas with our encrypted, privacy-focused note-taking platform." />
      </Head>
      <Simple>
        <SignIn />
      </Simple>
    </>
  );
}

SignInPage.layout = (page: React.ReactNode) => <PublicLayout children={page} />;
export default SignInPage;
